import { Component, OnInit } from '@angular/core';
import { StoreService } from './../../store.service';
import * as $ from "jquery";

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';


@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {
  constructor( private $store : StoreService ) { }

  loading: boolean
  disabled = this.$store.disabled
  customSvgCl = "svgSpan unRotated"
  searchedSkillType_obj = [
    { type : 'expertise', count : 0}, 
    { type : 'tool', count : 0}, 
    { type : 'IT langage', count : 0}, 
    { type : 'langage', count : 0}, 
  ]

  ngOnInit() {
    this.loading = true
    if (!this.$store.skills) {
      this.$store.getSkills()
      .catch(err => console.log(err))
      .then(() => this.loading = false) }
    else this.loading = false
    if (this.$store.resetSearchedSkills === true) 
     { this.$store.searchedSkills = [] }
    else { this.$store.resetSearchedSkills = true }
    

  }

  changeIcon(dom, ind) {
    // To change the 'plus' icon when toogling toogling filters
    $('#'+dom+'_plus_'+ind).css('display') === 'inline-block' ? 
      ($('#'+dom+'_plus_'+ind).css('display', 'none'),
       $('#'+dom+'_minus_'+ind).css('display', 'inline-block')) :
       ($('#'+dom+'_minus_'+ind).css('display', 'none'),
       $('#'+dom+'_plus_'+ind).css('display', 'inline-block'))
  }

  rotateSvg(arg) {
    $(arg).hasClass('unRotated') ? $(arg).removeClass('unRotated').addClass('rotated')
    : $(arg).removeClass('rotated').addClass('unRotated')
  }
  
  toggleSearchedSkill(id, level, certified?) {

    // searchedSkills is a global variable declared in the Store Service, which contains 
    // all the skills checked in the filters 

    // adds or removes a skill from the variable searchedSkills 
    const index = this.$store.searchedSkills
      .findIndex(skill => skill.id === id && (level ? skill.level === level : !skill.level && skill.certified === certified) )
      if (index > -1) {this.$store.searchedSkills.splice(index, 1)}
      else {this.$store.searchedSkills.push({ id, level, certified })}

    // turns the searchedSkills variable into an object structured according to 
    // the skill's id
    this.$store.searchedSkills_object = this.$store.searchedSkills.reduce(function (r, a) {
        r[a.id] = r[a.id] || [];
        r[a.id].push(a);
        return r;
    }, Object.create(null));

    // turns the searchedSkills_object into an array - to make it iterable 
    // this.$store.searchedSkills_array = []
    let foo = Object.entries(this.$store.searchedSkills_object)
    
    var i = 0
    // takes care of including a boolean for the certification field in each skill entry
    foo.forEach(
      s => (i = s[1].findIndex(x => !x.level && x.certified), 
            i > -1 ?
            ( s[1].length > 1 ?
                 s[1] = this.addCertification(s[1]):
                 s[1] = this.addCertificationOnly(s[1][0])
                 ) :
            s[1].forEach(x => x.certified = false)))
      this.$store.searchedSkills_array = foo
    
    // counting the number of filters displayed, according to their types

    // resetting the count field for each type attribute (see the searchedSkillType_obj declaration)
    this.searchedSkillType_obj.forEach(x => x.count = 0)
    // resetting the searchedSkillType variable, and populating it with the 
    // checked skills, to count them
    var searchedSkillType = []
    
    this.$store.searchedSkills_array.forEach(
      a => (
        // find the skill in the $store.skills variable thanks to its id, 
        // to then access its type
        searchedSkillType = this.$store.skills.filter(
            t => t.categories.find(c => c.skills.find (s => s.id === a[0]))), 
        // get the number of checked filters for that skill, and add one if 
        // 'certification' is checked
        a[1][0].certified ? (a[1].length = a[1].length + 1) : '',
        this.searchedSkillType_obj.filter(
        x => x.type === searchedSkillType[0].type
      )[0].count += a[1].length
    )
    ) 
  }

  addCertification(arrayOfObject) {
    let newArray = arrayOfObject.filter(x => x.level)
    newArray.forEach(x => x.certified = true)
    return newArray
  }

  // in case when only the certification is checked and no skill level, 
  // adds all levels to the SearchedSkills global variable
  addCertificationOnly(certifObject) {
    let arrayOfObject = [{id: certifObject.id, level: 1, certified : true},
      {id: certifObject.id, level: 2, certified : true},
      {id: certifObject.id, level: 3, certified : true}]
    return arrayOfObject
  }

  getDisabledValue() {
    // getter to check if the filters are disabled or not
    // the filters are disabled when the user processes to a search with the search bar
    // (see search-autocompl.ts)
    return this.$store.disabled
  }

  undisable() {
    // gets back the skills checked by the user before the filters were disabled 
    // (see search-autocompl.ts) and reupdates the $store.searchedSkills_array
    // and the $store.searchedSkills_object to display the previously filtered profiles
    if (this.$store.searchedSkills_inMemory !== undefined)
    {this.$store.searchedSkills = this.$store.searchedSkills_inMemory
      this.$store.searchedSkills_inMemory = undefined
      this.$store.searchedSkills_array = []
      this.$store.searchedSkills_object = this.$store.searchedSkills.reduce(function (r, a) {
          r[a.id] = r[a.id] || [];
          r[a.id].push(a);
          return r;
      }, Object.create(null));
      this.$store.searchedSkills_array = Object.entries(this.$store.searchedSkills_object)}
    this.$store.disabled = false
  }




}








// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/display-profiles/filter/filter.component.ts